import { useEffect, useState } from 'react';

export default function ScrollProgress() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(docHeight > 0 ? (scrollTop / docHeight) * 100 : 0);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[9997] h-[2px]"
      style={{ background: 'rgba(255,255,255,0.04)' }}
      data-testid="scroll-progress"
    >
      <div
        className="h-full"
        style={{
          width: `${progress}%`,
          background: 'linear-gradient(90deg, #00F0FF, #4A90D9)',
          boxShadow: '0 0 12px rgba(0, 240, 255, 0.8)',
          transition: 'width 0.05s linear',
        }}
      />
    </div>
  );
}
